import { useSelectedSites } from "@medoma/shared-employee/selectedSites";
import { siteIdSchema, type SiteId } from "@medoma/models/sites";
import { useAuth } from "react-oidc-context";

/**
 * Returns the single site selected in Center.
 *
 * The shared selected-sites API is array-shaped, but Center currently has an
 * active-site model: SiteSelector and SiteSwitcher always store exactly one
 * site. Keep the temporary first-item decision here instead of spreading
 * `sites[0]` or array stringification across consumers. If Center later gains
 * a distinct active-site policy alongside multi-site selection, it should be
 * implemented at this boundary.
 */
export const useSelectedSite = (): SiteId | null => {
  const { user } = useAuth();
  if (!user) {
    throw new Error("Should have user when reading the selected site");
  }

  const selectedSites = useSelectedSites(user.profile.sub);
  const selectedSite = selectedSites?.[0];

  return selectedSite === undefined ? null : siteIdSchema.parse(selectedSite);
};
